import React from 'react';
import styled from 'styled-components';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import * as toc from '../../../left-toc.json';
import { Ajax } from '@syncfusion/ej2-base';

var demosLink = toc.demos;
var logoLink = 'https://help.syncfusion.com/';

var platformMapper = {
  'JavaScript': 'essential-js2',
  'JavaScript (ES5)': 'essential-js2',
  'Angular': 'angular',
  'React': 'react',
  'Vue': 'vue',
  'ASP.NET Core': 'aspnetcore-js2',
  'ASP.NET MVC': 'aspnetmvc-js2',
  'Blazor': 'blazor'
};

// Support for upgrade guide btn

var upgradeGuideMapper = {
  'JavaScript': 'https://help.syncfusion.com/upgrade-guide/typescript',
  'JavaScript (ES5)': 'https://help.syncfusion.com/upgrade-guide/javascript-ui-controls',
  'Angular': 'https://help.syncfusion.com/upgrade-guide/angular-ui-components',
  'React': 'https://help.syncfusion.com/upgrade-guide/react-ui-components',
  'Vue': 'https://help.syncfusion.com/upgrade-guide/vue-ui-components',
  'ASP.NET Core': 'https://help.syncfusion.com/upgrade-guide/aspnet-core-ui-controls',
  'ASP.NET MVC': 'https://help.syncfusion.com/upgrade-guide/aspnet-mvc-ui-controls',
  'Blazor': 'https://help.syncfusion.com/upgrade-guide/blazor-components'
};

// var aspRegex = /ASP.NET Core|ASP.NET MVC|Blazor \[Preview\]/;

class MainHeader extends React.Component {

constructor(props) {
  super(props);
  this.onFilterVersion = this.onFilterVersion.bind(this);
  this.onFilterCreated = this.onFilterCreated.bind(this);
  this.dropObj = {};
  this.filterData = [
    {
        dropName: '18.1', dropId: '1'
    },
    {
      dropName: '18.2', dropId: '2'
    },
    {
      dropName: '18.3', dropId: '3'
    },
    {
      dropName: '18.4', dropId: '4'
    },
    {
      dropName: '19.1', dropId: '5'
    },
    {
      dropName: '19.2', dropId: '6'
    }
];
  this.dropField = { value: 'dropId', text: 'dropName' };
  this.index = 5;
}

onFilterVersion() {
  if (!this.dropObj.value) {
    return;
  }
  if (this.dropObj.value === this.filterData[this.filterData.length-1].dropId) {
    window.location.href = window.location.href.split(/[1-9]+\.+[1-9]/).join('');
  } else {
    if (!/[1-9]/.test(window.location.href)) {
      window.location.href = window.location.href.split('documentation').join(this.dropObj.text + '/documentation');
    } else {
      window.location.href = window.location.href.split(/[1-9]+\.+[1-9]/).join(this.dropObj.text);
    }
  }
}

onFilterCreated() {
  var ajax = new Ajax('https://cdn.syncfusion.com/ej2/version-list.json', 'GET', true);
    ajax.send().then();
    ajax.onSuccess = (data) => {
      var datas = JSON.parse(data).VersionLists;
      this.filterData = datas;
      this.dropObj.dataSource = datas;
      var version = '19.2';
      for (var i =0; i<this.dropObj.dataSource.length; i++) {
        if (this.dropObj.dataSource[i].dropName === version) {
          this.dropObj.index = i;
          return;
        } 
      }
    };
}

  /* eslint-disable */
  render() {
    const { platform } = this.props;
    return (
      <SiteContainer>
        <div id="version-support" style={{top: '14px',width: '68px',position: 'absolute',left: '232px'}}>
        <DropDownListComponent id="country-dd" iconCss='filter-drop' ref={(scope) => { this.dropObj = scope; }} index={this.index} fields={this.dropField} dataSource={this.filterData} created={this.onFilterCreated} change={this.onFilterVersion}/>
        </div>
        <div className="doc-icons icon-burger_menu doc-hamburger-icon"></div>
        <a className="doc-logo-link" href={logoLink}><div className="doc-logo doc-icons icon-syncfusion"></div></a>
        <div className="doc-header-platform">{platform}</div>
        <a id='editme' className='doc-edit-me'><span id="icon-edit"></span><span className="doc-editme-link doc-demos-link">Edit</span><span className="tooltiptext">Edit This Document</span></a>
        <div className={"doc-header-links" + (platform === 'Blazor' ? ' razor-doc-links' : '')}>
          <a href={demosLink} target="_blank"><div className="doc-header-link doc-demos-link">Demos</div></a>
          <a href="https://www.syncfusion.com/support/directtrac/incidents" target="_blank"><div className="doc-header-link doc-support-link">Support</div></a>
          <a href={`https://www.syncfusion.com/forums/${platform === 'Blazor'? 'blazor-components' : platformMapper[platform]}`} target="_blank"><div className="doc-header-link doc-forum-link">Forum</div></a>
          <a id = 'upgrade-guide' href={`${upgradeGuideMapper[platform]}`} target="_blank"><div className="doc-header-link">Upgrade Guide</div></a>
          <a href={`https://www.syncfusion.com/downloads/${ platformMapper[platform] }`} target="_blank"><div className="doc-header-link doc-download-link">FREE TRIAL</div></a>
        </div>
      </SiteContainer>
    )
  }
}

const SiteContainer = styled.div`
  background: ${props => props.theme.brand};
  padding: 0px 20px;
  @media screen and (max-width: 764px) {
    padding: 0px 10px;
  }
`

export default MainHeader
